/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import DTORecurringPaymentARModal from './DTORecurringPaymentARModal';
import RecurringPaymentARModalPresenter from './RecurringPaymentARModalPresenter';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import { useAppSelector } from '../../../../infra/hooks';
import { actionRequiredService } from '../../../../api/services/actionRequiredService';

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  fullData?: any;
}

const RecurringPaymentARModalController = ({
  isModalOpen,
  closeModal,
  fullData,
}: ModalInterface) => {
  const [allActions, setAllActions] = useState([]);
  const selector = useAppSelector((state) => state.authSlice);

  const { t } = useTranslation();
  const getActions = (act: any) => {
    setAllActions(act);
  };
  const hitAction = (payload: any) => {
    actionRequiredService
      .finalActionSubmitActionRequired(payload)
      .then((res: any) => {
        if (res?.response == 'success') {
          toast.success('Action Performed Successfully!');
          closeModal();
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.data);
      });
  };
  return (
    <>
      <DTORecurringPaymentARModal setDaAllActions={getActions} />

      <RecurringPaymentARModalPresenter
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        trans={t}
        fullData={fullData}
        userId={selector.user_id}
        allActions={allActions}
        handleSubmitAR_Request={hitAction}
      />
    </>
  );
};

export default RecurringPaymentARModalController;
